export const AUTH_URL = process.env.REACT_APP_AUTH_URL || '';
export const APP_URL = process.env.REACT_APP_URL || '';
